import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/index.ts";
import ShowContainer from "../../mui/ShowContainer.jsx";

export default function PromoCodeSuccess({ info }) {
  const { t } = useTranslation();
  const channelUrl = useAppSelector((state) => state.links.channelUrl);

  const { amount, currency } = info;

  return (
    <div className="promo-code__success">
      <div className={"promo-code-credited"}>
        <div className="promo-code-credited__kicker">
          <span className="promo-code-credited__kicker-icon">🎉</span>
          {t("Promo code activated")}
        </div>

        <div className="promo-code-credited__amount-row">
          <span className="promo-code-credited__amount">
            +{amount}
            <span className="promo-code-credited__currency">{currency}</span>
          </span>
          <span className="promo-code-credited__amount-label">{t("credited to the balance")}</span>
        </div>

        <p className="promo-code-credited__text">
          {t("Congratulations, you are faster than other players.")}
        </p>

        <div className="promo-code-credited__note">
          <span className="promo-code-credited__note-icon">📢</span>
          <div className="promo-code-credited__note-body">
            <p className="promo-code-credited__note-text">
              {t("This is not your last promo code, catch new promo codes on our channel")}
            </p>

            <ShowContainer condition={channelUrl}>
              <a
                className="promo-code-credited__note-link"
                href={channelUrl}
                target="_blank"
                rel="noopener noreferrer">
                {t("Open channel")} →
              </a>
            </ShowContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
